<div class="pos-r">
  <app-loader *ngIf="loading"></app-loader>
  <div class="pt-24 pb-24">
    <div class="grid">
      <div class="grid__box grid__box--size-5">
        <div class="grid">
          <div class="grid__box grid__box--size-6">
            <div class="title title--s">
              Число дней неактивности клиента,<br />
              начиная с которого он считается<br />
              неактивным
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="days-count__block">
              <app-field>
                <input type="text" class="input-text" maxlength="8" fieldRegexp [regexp]="'[^0-9]'" [(ngModel)]="inactivityDaysTreshold" />
              </app-field>
            </div>
          </div>
        </div>
      </div>

      <div class="grid__box grid__box--size-5">
        <div class="grid">
          <div class="grid__box grid__box--size-6">
            <div class="title title--s">
              Время ожидания ответа<br />
              Quality Keeper в секундах
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div class="days-count__block">
              <app-field>
                <input type="text" class="input-text" maxlength="8" fieldRegexp [regexp]="'[^0-9]'" [(ngModel)]="qkResponsesTimeout" />
              </app-field>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-16" *ngIf="generalSettingsError">
      <app-message [type]="'error'">
        <div message-content>{{ generalSettingsError }}</div>
      </app-message>
    </div>

    <div class="mt-16" *ngIf="generalSettingsSuccess">
      <app-message [type]="'success'">
        <div message-content>{{ generalSettingsSuccess }}</div>
      </app-message>
    </div>

    <div class="mt-32">
      <button class="button" type="button" [disabled]="!inactivityDaysTreshold" (click)="onSaveGeneralSettings()">Сохранить</button>
    </div>
  </div>
</div>
